import { useInfiniteQuery } from "@tanstack/react-query";
import { array, object, number, string } from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import {
  composePaginationSchema,
  getNextPaginationPage,
  paginationSchema,
} from "../../schemas/pagination";
import { smsSnippetSchema } from "./schemas";
import { removeNullishFromShape } from "../../utilities/general";
import { smsSnippetAdapter } from "./utilities";

const requestSchema = object({
  pageSize: number().required(),
  search: string().nullable(),
});

const responseSchema = paginationSchema.concat(
  object({
    snippets: array().of(smsSnippetSchema).required(),
  }),
);

const composeResponse = (res, req) => {
  return {
    ...composePaginationSchema({
      response: res?.data?.data || {},
      pageSize: req.pageSize,
    }),
    snippets: res?.data?.data?.data?.map(smsSnippetAdapter),
  };
};

export const usePaginatedSmsSnippetsQuery = (payload, options = {}) => {
  const req = requestSchema.validateSync(payload, {
    strict: true,
  });

  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.smsSnippets.paginated, req.pageSize, req.search],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await http.get(HTTP_ENDPOINTS.smsSnippets.getAll(), {
        params: removeNullishFromShape({
          page: pageParam,
          per_page: req.pageSize,
          search: req.search || null,
        }),
      });
      return responseSchema.validateSync(composeResponse(res, req), {
        strict: true,
      });
    },
    ...options,
    getNextPageParam: getNextPaginationPage,
  });
};
